/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dropwinnersresendconfirmbody4Inputs */

const en_dropwinnersresendconfirmbody4 = /** @type {(inputs: Dropwinnersresendconfirmbody4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.count} winners already received this drop's winner message. Sending again delivers a second DM to each of them.`)
};

const de_dropwinnersresendconfirmbody4 = /** @type {(inputs: Dropwinnersresendconfirmbody4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} Gewinner haben die Nachricht schon bekommen. Wenn du nochmal sendest, bekommt jeder eine zweite Nachricht.`)
};

/**
* | output |
* | --- |
* | "All {count} winners already received this drop's winner message. Sending again delivers a second DM to each of them." |
*
* @param {Dropwinnersresendconfirmbody4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersresendconfirmbody4 = /** @type {((inputs: Dropwinnersresendconfirmbody4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersresendconfirmbody4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersresendconfirmbody4(inputs)
	return de_dropwinnersresendconfirmbody4(inputs)
});
export { dropwinnersresendconfirmbody4 as "dropWinnersResendConfirmBody" }